<template>
    <div class="lezhi-project1">
        <headerBlack-view></headerBlack-view>
        <div class="wrapper ">
            <div class="introduce_wrap flex-layout main">
                <div class="introduce_left">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">项目介绍</h2>
                            <img src="@/assets/yunqiao/introduce.png" />
                        </div>
                    </div>
                    <div class="introduce_name">京银互动一带一路共读工程</div>
                    <div class="introduce_detail">
                      遴选项目校，开发校本书单和校本题库，其中将建立示范校覆盖智能图书分享系统，
                      包含智能校园书柜、智能图书分享系统软件模块，中小学校园阅读跟踪测评系统，向所有师生开放并可永久使用。
                      针对项目校每年进行线下集中阅读教学培训及赛课指导，每年进行若干次线上阅读教学培训，打造本地的阅读种子教师。
                      针对合作地区全境开展全国性阅读大赛、线上活动以及每年线下阅读活动。对每位学生进行阅读全过程数据评测服务。成果论文集的出版，协助合作地区主办全国性的阅读高峰论坛和展会，发布共读白皮书。
                    </div>
                </div>
                <div class="introduce_right flex-layout ">
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/road/01.png" />
                        <h3>课堂互通</h3>
                        <span>Classroom Sharing</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/road/02.png" />
                        <h3>资源输出</h3>
                        <span>Resource Exchange</span>
                    </div>
                    <div class="introduce_item flex-column-center">
                        <img src="@/assets/yunqiao/road/03.png" />
                        <h3>数据支持</h3>
                        <span>Win-Win</span>
                    </div>
                </div>
            </div>    
            <div class="features-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu_white.png" />
                        <div class="">
                            <h2 class="f28" style="color:white">产品特点</h2>
                            <img src="@/assets/yunqiao/feature.png" />
                        </div>
                    </div>
                    <div class="features-items flex-align-between">
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon01.png" alt="">
                            <h3>精准落地互动</h3>
                            <p>合作双负责人确保合作精准<br>落地</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon02.png" alt="">
                            <h3>专家教师</h3>
                            <p>首师中文自然语言处理专家、<br> 中文教师优质输出</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon03.png" alt="">
                            <h3>语言学习互帮互助</h3>
                            <p>汉语推广和非通用语种学习<br>中互相交流，传承文化</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon04.png" alt="">
                            <h3>中文系列阅读课程资源</h3>
                            <p> 高水准的精品教育资源信息</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon05.png" alt="">
                            <h3>资质与培训</h3>
                            <p>国际化的资质认定与培训,让<br>成长在努力化为果实</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/yunqiao/road/icon06.png" alt="">
                            <h3>多样化中文阅读活动</h3>
                            <p>先悦读、在阅读。在各类中<br>文阅读活动中真正实现在做<br>中学，学中做</p>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="architecture-wrap">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">架构形式</h2>
                            <img src="@/assets/yunqiao/architecture.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="left-article">
                            <div class="section section-one flex-layout">
                                <h2>01</h2>
                                <div class="describe">
                                    <h3>核心</h3>
                                    <p>师生素养提升为核心，围绕阅读文化、阅读资源、阅读课程、跟踪评价工具、
                                        阅读活动以及长效化机制多方面、
                                        多角度系统化开展，营造校园阅读氛围，实现师生的综合发展。</p>
                                </div>
                            </div>
                            <div class="section section-two flex-layout">
                                <h2>03</h2>
                                <div class="describe">
                                    <h3>北京课堂  银川课堂</h3>
                                    <p>京银两地同屏共享课堂，创设学习情境、设置学习任务与计划，
                                        使银川市师生和一带一路沿线居民在汉语推广和非通用语种学习中互帮互助。</p>
                                </div>
                            </div>
                        </div>
                        <div class="line flex-column">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                        <div class="right-article">
                            <div class="section section-three flex-layout">
                                <h2>03</h2>
                                <div class="describe">
                                    <h3>课堂、辅导、测评、活动</h3>
                                    <p>京银两地师生参加四同活动：同上课、同辅导、同测评，同活动，
                                        使学习者获得优质课程资源和精准化学习资源，以及经过评测后定制化的学习辅导和特色社团服务，
                                        使指导者增加相互交流和提升的机会，实现优势互补。</p>
                                </div>
                            </div>
                            <div class="section section-four flex-layout">
                                <h2>04</h2>
                                <div class="describe">
                                    <h3>数据分析</h3>
                                    <p>依托大数据支持，充分了解学校阅读基础和需求，通过课堂教学、
                                        教师培养、校本书单定制、智能图书共读系统、智能大数据监测终端、
                                        一带一路的活动等来实现“首都+首府”的教育互联互助。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="win-wrap-model-one">
                <div class="main">
                    <div class="title flex-layout">
                        <img src="@/assets/yunqiao/menu.png" />
                        <div class="">
                            <h2 class="f28">合作共赢</h2>
                            <img src="@/assets/yunqiao/win2.png" />
                        </div>
                    </div>
                    <div class="container flex-layout">
                        <div class="right-box flex-layout">
                             <div class="img-wrap">
                                <img src="@/assets/yunqiao/road/06.png" alt="">
                                <span>千所院校共同进步</span>
                            </div>
                            <div class="img-wrap">
                                <img src="@/assets/yunqiao/road/07.png" alt="">
                                <span>多品类项目活动</span>
                            </div>
                            <div class="img-wrap">
                                <img src="@/assets/yunqiao/road/08.png" alt="">
                                <span>优秀教师精准提升</span>
                            </div>
                            <div class="img-wrap">
                                 <img src="@/assets/yunqiao/road/09.png" alt="">
                                 <span>优质学生作品</span>
                            </div>
                        </div>
                        <div class="left-img">
                            <img src="@/assets/yunqiao/road/05.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="less" scoped>
    @import "./less/lezhi_common.less";
    // @import "./less/lezhi_project1.less";

    .lezhi-project1 {
    background-color: #FFFFFF;
    
    .features-wrap {
        overflow: hidden;
        
        min-width: 1280px !important;
        max-width: 1920px;
        
        background-image:url("../../assets/yunqiao/road/bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50% 0 ;
    
        .features-items {
            flex-flow: row wrap;
            align-content: flex-start;
            
            margin: 89px auto 0;
            margin-top: 89px;
            text-align: center;

            .item {
                flex: 0 0 33.33%;
                margin-bottom: 74px;

                color: #fff;

                img {
                    margin-bottom: 46px;
                }

                h3 {
                    margin-bottom: 25px;

                    font-weight: bold;
                    font-size: 20px;
                }
                p {
                    min-height: 95px;
                    line-height: 32px;
                    font-weight: bold;
                    font-size: 16px;
                }

            }
        }
    }

    .architecture-wrap {

        .container{
            margin-top: 90px;
        }

        div.section  {
            box-sizing: border-box;
            
            position: relative;
            
            margin-bottom: 64px;
            border-radius: 20px;
            padding: 25px 30px 0 30px;
            width: 545px;
            height: 196px;
            
            background-color: #1C4B90;
            
            &::after {
                content: ' ';
                display: inline-block;
                
                position: absolute;
                top: 50%;
                right: -18px;
                
                border-top: 16px solid transparent;
                border-bottom: 16px solid transparent;
                width: 0;
                height: 0;
                transform: translateY(-50%);
            }

            &.section-one::after ,
            &.section-two::after {
                border-left: 21px solid #1C4B90;
            }   
            &.section-three::after ,
            &.section-four::after {
                left: -18px;
                border-right: 21px solid #1C4B90;
            }   


            h2 {
                position: relative;
                
                margin-right: 31px;

                font-size: 38px;
                font-weight: bold;
                color: #fff;

                &::before,
                &::after {
                    content: ' ';

                    display: block;
                    position: absolute;
                    top: 55px;
                    left: 0;
                }

                &::before {
                    width: 45px;
                    height: 22px;
                    background-color: rgba(90,151,241,0.27);
                    
                }
                &::after {
                    left: 45px;
                    width: 0;
                    height: 0;
                    border-top: 11px solid transparent;
                    border-bottom: 11px solid transparent;
                    border-left: 14px solid rgba(90,151,241,0.27);
                }
            }

            h3 {
                font-size:28px;
                font-weight:bold;
                color:#fff;
                margin-bottom: 20px;
            }

            p {
                font-size:15px;
                color:#fff;
            }
        }

        div.line {
            align-items: center;
            
            position: relative;

            margin-top: -20px;
            width: 120px;
            
            &::before {
                content: ' ';
                
                position: absolute;
                top: 0;
                left: 50%;
                
                width:5px;
                height:480px;
                
                background-image: linear-gradient(#1B4B8F,#1B4B8F,#1B4B8F,#1B4B8F, #fff);
                transform: translateX(-50%);
            }

          .dot {
                position: relative;
                z-index: 999;
                
                margin-bottom: 236px;
                border:3px solid #fff;
                border-radius:50%;
                width:20px;
                height:20px;
               
                background-color:#1B4B8F;
                
                &:first-child {
                    margin-bottom: 70px;

                    width:29px;
                    height:29px;
                }
            }
        }
    }
}
</style>